export function buildMnemonicImageUrl(fileName: string): string {
    return `/api/virtual-devices/mnemonic-file/${fileName}`;
}

export function stripAuthTokenFromUrl(src: string): string {
    return src.replace(/([?&])authorizationToken=[^&]+(&)?/, (_, prefix: string, suffix?: string) => (suffix ? prefix : '')).replace(/[?&]$/, '');
}

export function extractMnemonicFileNameFromSrc(src: string): string | null {
    const match = src.match(/\/mnemonic-file\/([^/?]+)/);
    return match?.[1] ?? null;
}
